var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoggingService as logger } from "@/logging/LoggingService";
import { getCmi5 } from "@/cmi5/cmi5Api/cmi5";
let canClose = false;
let initialized = false;
export const Cmi5SessionTerminator = {
    initialize: () => {
        if (initialized) {
            return;
        }
        window.addEventListener("beforeunload", (event) => {
            if (!canClose) {
                event.preventDefault();
                event.returnValue = "";
            }
        });
        initialized = true;
    },
    terminate: () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            logger.debug("Terminate CMI5 Session...");
            yield getCmi5().terminate().finally(() => {
                canClose = true;
                closeCourseWindow();
            });
        }
        catch (e) {
            logger.error(`ERROR on ExitAU: Request failed - ${e}`);
        }
    })
};
/**
 * Attempt to navigate the browser or close the current window relative to whatever way the course has been launched.
 *
 * @private
 */
function closeCourseWindow() {
    if (window.opener) {
        try {
            window.close();
        }
        catch (e) {
            logger.error(e);
        }
    }
}
